import { Fragment } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const styles = {
  skeleton: {
    width: 700,
    height: 10,
  },
};

const FullContentSkeleton = () => {
  return (
    <SkeletonTheme>
      <div className="row flex-wrap overflow-h ">
        <div className="col-12 d-flex justify-content-center">
          <Skeleton circle={true} height={60} width={60} />
        </div>
        <div className="col-12 d-flex justify-content-center mt-3">
          <p className="m-0 p-0">
            <Skeleton height={10} width={150} />
          </p>
        </div>
        <div className="col-12 d-flex justify-content-center">
          <p className="m-0 p-0">
            <Skeleton height={10} width={180} />
          </p>
        </div>
        <div className="col-12 d-flex justify-content-center mb-4">
          <p className="m-0 p-0">
            <Skeleton height={10} width={80} />
          </p>
        </div>
        {Array.from(Array(15).keys()).map((e, i) => {
          return (
            <Fragment key={i}>
              <div className="col-12 d-flex justify-content-center mt-1">
                <p className="m-0 p-0">
                  <Skeleton style={styles.skeleton} />
                </p>
              </div>
            </Fragment>
          );
        })}
      </div>
    </SkeletonTheme>
  );
};

export default FullContentSkeleton;
